import { Node } from '@tiptap/core'

export const Center = Node.create({
  name: 'center',
  group: "block",
  content: 'block+',
  defining: true,
  parseHTML() {
    return [{ tag: "center" }]
  },
  renderHTML({ HTMLAttributes }) {
    return ['center', HTMLAttributes, 0];
  },
})